export const state = {
  isContinueAction: true
};

export const getters = {
  isContinueAction: state => state.isContinueAction,
};

export const mutations = {
  changeContinueActionStatus(state, status) {
    state.isContinueAction = status;
  },
};
